// アプリケーション設定

export const AppConfig = {
  // 画像生成設定
  generation: {
    maxFileSize: 100 * 1024 * 1024, // 100MB
    minFileSize: 100, // 100 bytes
    maxIterations: 50,
    qualitySteps: 12,
    defaultQuality: 0.8,
    
    // サイズ計算設定
    sizeCalculation: {
      minDimension: 1,
      maxDimension: 4096,
      aspectRatios: [
        { width: 1, height: 1 },   // 正方形
        { width: 4, height: 3 },   // 4:3
        { width: 16, height: 9 },  // 16:9
        { width: 3, height: 2 },   // 3:2
      ]
    },
    
    // 品質調整設定
    qualityAdjustment: {
      minQuality: 0.05,
      maxQuality: 1.0,
      stepSize: 0.05,
      tolerance: 10 // バイト
    }
  },
  
  // UI設定
  ui: {
    progressUpdateInterval: 100, // ms
    debugMode: false,
    animationDuration: 300, // ms
    
    // 入力設定
    input: {
      debounceDelay: 300, // ms
      placeholder: '1000',
      step: 1
    },
    
    // 進捗表示設定
    progress: {
      showEstimatedTime: true,
      estimatedTimeThreshold: 10 * 1024 * 1024, // 10MB
      phases: {
        'size-calculation': '画像サイズ計算中...',
        'quality-adjustment': '品質調整中...',
        'binary-padding': 'ファイナライズ中...'
      }
    }
  },
  
  // パフォーマンス設定
  performance: {
    memoryThreshold: 200 * 1024 * 1024, // 200MB
    chunkSize: 1024 * 1024, // 1MB chunks for large files
    enableMemoryMonitoring: true,
    gcThreshold: 50 * 1024 * 1024, // 50MB
    
    // 大容量ファイル警告
    warningThresholds: {
      size: 50 * 1024 * 1024, // 50MB
      time: 30 * 1000 // 30秒
    }
  },
  
  // エラーハンドリング設定
  error: {
    maxRetries: 3,
    retryDelay: 1000, // ms
    showTechnicalDetails: false,
    
    // エラーメッセージ
    messages: {
      input: {
        tooSmall: 'ファイルサイズは100バイト以上である必要があります',
        tooLarge: 'ファイルサイズは100MB以下である必要があります',
        invalid: '有効な数値を入力してください'
      },
      memory: {
        insufficient: 'メモリ不足です。より小さなサイズをお試しください',
        threshold: 'メモリ使用量が制限を超えました'
      },
      algorithm: {
        failed: '画像生成に失敗しました',
        timeout: '処理がタイムアウトしました'
      },
      browser: {
        unsupported: 'お使いのブラウザはサポートされていません',
        canvasError: 'Canvas APIでエラーが発生しました'
      }
    }
  },
  
  // ログ設定
  logging: {
    level: 'INFO', // DEBUG, INFO, WARN, ERROR, FATAL
    maxLogs: 1000,
    enableConsole: true,
    enableStorage: false
  },
  
  // ファイル設定
  file: {
    defaultFilename: 'generated-image',
    extension: '.jpg',
    mimeType: 'image/jpeg'
  },
  
  // GitHub Pages設定
  deployment: {
    basePath: './',
    enableServiceWorker: false
  },

  // バックエンドAPI設定
  backend: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    timeout: 120000, // 2分
    
    // エラーハンドリング
    retry: {
      maxRetries: 2,
      retryDelay: 2000, // 2秒
      exponentialBackoff: true
    }
  }
} as const;

// 型安全なconfig取得関数
export function getConfig<T extends keyof typeof AppConfig>(section: T): typeof AppConfig[T] {
  return AppConfig[section];
}

// 環境変数での設定上書き（将来の拡張用）
export function overrideConfig(overrides: Partial<typeof AppConfig>): void {
  Object.assign(AppConfig, overrides);
} 